module.exports = __webpack_public_path__ + "img/reference67.072072d6.jpg";